import { render, staticRenderFns } from "./recipients.vue?vue&type=template&id=0b4f4d06&scoped=true&"
import script from "./recipients.vue?vue&type=script&lang=js&"
export * from "./recipients.vue?vue&type=script&lang=js&"
import style0 from "./recipients.vue?vue&type=style&index=0&id=0b4f4d06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4f4d06",
  null
  
)

export default component.exports